import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessFair} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessFairPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MyBusinessFairPage;
  }

  render() {
    return (
      <MasterLayout isActive='my-business-news'>
        <MyBusinessFair params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessFairPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessFairPage.jsx